export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      resource: 'Dashboard',
      action: 'read',
    },
  },
  {
    path: '/dashboardWorkflow',
    name: 'dashboardWorkflow',
    component: () => import ('@/views/dashboard/DashboardSoftwareWorkflow.vue'),
    meta: {
      resource: 'Dashboard',
      action: 'read',
    },
  },
]
